import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type CardHeaderSubtitleProps = React.HTMLAttributes<HTMLDivElement>;

export const CardHeaderSubtitle = ({
  className,
  ...props
}: CardHeaderSubtitleProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-card__header-subtitle');
  return <div className={classNames} data-theme={theme} {...props} />;
};

CardHeaderSubtitle.displayName = 'CardHeaderSubtitle';
